export default __webpack_public_path__ + "b8fcd9e6d1d9aab2f3ffb36d609115a0.jpg";